import { inject, Service } from '@angular/core';
import StackTrace from 'stacktrace-js';

import { LogLevel } from './logger.model';
import { LOGGERS } from './logger.token';

const DEFAULT_EXCEPTION = 'No stack trace available';
const FRAMES_LIMIT = 2;

@Service()
export class LoggerService {
  readonly #loggers = inject(LOGGERS);

  handleHttpError<T>(error: T): void {
    this.#loggers
      .filter((r) => r.available())
      .forEach((r) => r.saveHttpLog<T>(error));
  }

  async handleJsError(error: Error, level: LogLevel = 'error'): Promise<void> {
    let exception = DEFAULT_EXCEPTION;

    try {
      const frames = await StackTrace.fromError(error);

      if (frames.length > 0) {
        exception = [
          frames[0].getFileName(),
          frames[0].getLineNumber(),
          frames[0].getColumnNumber(),
        ].join(':');
      }
    } catch {
      exception = error.stack
        ?.split('\n')
        ?.slice(0, FRAMES_LIMIT)
        ?.map((v) => v.trim())
        ?.join(':') ?? DEFAULT_EXCEPTION;
    }

    this.#loggers
      .filter((r) => r.available())
      .forEach((r) => r.saveJsLog(error, exception, level));
  }
}
